import { colors, InputText } from '@insurancemenu/imenu-components-lib';
import FormModal from '@insurancemenu/imenu-components-lib/dist/components/modals/FormModal';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { RequestSignatureModalStore } from 'store/modules/upload-documents/ui-stores/requestSignatureModalStore';
import { FileSignature } from '@insurancemenu/imenu-components-lib/dist/icons';
import { ContentWrapperStyled } from './styles';
import {
  REQUEST_SIGNATURE_EMAIL_TEST_ID,
  REQUEST_SIGNATURE_MODAL_TEST_ID,
  REQUEST_SIGNATURE_NAME_TEST_ID,
} from '../constants';

interface Props {
  modalStore: RequestSignatureModalStore;
}

export const RequestSignatureModal: React.FC<Props> = observer(({ modalStore }) => {
  const { form, isLoading, sendSignatureRequest, resetForm, modalDelegate, backEndEmailValidationError } = modalStore;

  function handleClose(): void {
    resetForm();
    modalDelegate.close();
  }

  return modalDelegate.isVisible ? (
    <FormModal
      title="Request Signature"
      show={modalDelegate.isVisible}
      onClose={handleClose}
      onSubmit={sendSignatureRequest}
      loading={isLoading}
      isFormValid={form.basicFieldsValidationsPassed}
      icon={<FileSignature width="5.6rem" color={colors.green[600]} />}
      formContent={
        <ContentWrapperStyled>
          <InputText
            label="Name"
            name="name"
            value={form.fields.name.value}
            validationPassed={!form.fields.name.unpassedValidationMsg}
            validationMessage={form.fields.name.unpassedValidationMsg}
            maxLength={100}
            onChange={form.onFieldChange}
            width="100%"
            data-test-id={REQUEST_SIGNATURE_NAME_TEST_ID}
          />
          <InputText
            label="Email"
            name="email"
            value={form.fields.email.value}
            validationPassed={!form.fields.email.unpassedValidationMsg && !backEndEmailValidationError}
            validationMessage={form.fields.email.unpassedValidationMsg || backEndEmailValidationError}
            maxLength={100}
            onChange={form.onFieldChange}
            width="100%"
            data-test-id={REQUEST_SIGNATURE_EMAIL_TEST_ID}
          />
        </ContentWrapperStyled>
      }
      submitButtonText="Send"
      closeButtonText="Cancel"
      data-test-id={REQUEST_SIGNATURE_MODAL_TEST_ID}
    />
  ) : null;
});
